// extracted by mini-css-extract-plugin
export default {"loadingPageContainer":"InitialLoadingScreen_loadingPageContainer__7Ol-B","svgLogo":"InitialLoadingScreen_svgLogo__Bbcjw","maximalSearch":"InitialLoadingScreen_maximalSearch__AFQKN"};